import _regeneratorRuntime from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { useReducer as i } from "react";
import { RequestStates as u } from "./request.js";

var s = /* @__PURE__ */function (r) {
  return r.LOAD_MORE = "LOAD_MORE", r.RELOAD = "RELOAD", r.SEARCH = "SEARCH", r.SET_ERROR = "SET_ERROR", r.SET_LOADING = "SET_LOADING", r;
}(s || {});

function I(r, e) {
  var _e$searchInput;

  switch (e.type) {
    case s.LOAD_MORE:
      return _objectSpread(_objectSpread({}, r), {}, {
        abortController: e.abortController,
        error: null,
        items: [].concat(_toConsumableArray(r.items), _toConsumableArray(e.items)),
        marker: e.marker,
        requestState: u.SUCCESS
      });

    case s.RELOAD:
      return e.abortController !== r.abortController ? r : _objectSpread(_objectSpread({}, r), {}, {
        abortController: null,
        error: null,
        items: _toConsumableArray(e.items),
        marker: e.marker,
        requestState: u.SUCCESS,
        searchInput: ""
      });

    case s.SEARCH:
      return _objectSpread(_objectSpread({}, r), {}, {
        abortController: e.abortController,
        error: null,
        items: _toConsumableArray(e.items),
        marker: e.marker,
        requestState: u.SUCCESS,
        searchInput: (_e$searchInput = e.searchInput) !== null && _e$searchInput !== void 0 ? _e$searchInput : r.searchInput
      });

    case s.SET_ERROR:
      return _objectSpread(_objectSpread({}, r), {}, {
        items: s.LOAD_MORE ? r.items : [],
        error: e.error,
        requestState: u.ERROR
      });

    case s.SET_LOADING:
      return _objectSpread(_objectSpread({}, r), {}, {
        requestInitiator: e.requestInitiator,
        requestState: u.IN_PROGRESS,
        abortController: e.abortController
      });

    default:
      throw new Error("Invalid action type \"".concat(e.type, "\""));
  }
}

function E(r, e) {
  return r.type === s.SEARCH && e.requestState === u.IN_PROGRESS;
}

function S(r, e) {
  return e.requestInitiator === s.LOAD_MORE && e.requestState === u.IN_PROGRESS && r.type === s.LOAD_MORE;
}

function a(r, e) {
  return E(r, e) || S(r, e);
}

function m(r, e) {
  var t;
  E(r, e) && e.abortController.abort(), S(r, e) && ((t = r.abortController) == null || t.abort());
}

function p(r, e) {
  return S(r, e);
}

function R(_x, _x2, _x3, _x4) {
  return _R.apply(this, arguments);
}

function _R() {
  _R = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(r, e, t, n) {
    var l, _r$searchInput, _ref, _o$searchInput, o, O;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            l = new AbortController();

            if (!(a(r, t) && m(r, t), !p(r, t))) {
              _context.next = 16;
              break;
            }

            n({
              type: s.SET_LOADING,
              requestInitiator: r.type,
              abortController: l
            });
            _context.prev = 3;
            _context.next = 6;
            return e({
              items: t.items.slice(),
              signal: l.signal,
              marker: r.type === s.LOAD_MORE ? t.marker : null,
              searchInput: (_r$searchInput = r.searchInput) !== null && _r$searchInput !== void 0 ? _r$searchInput : t.searchInput
            });

          case 6:
            o = _context.sent;
            O = (_ref = (_o$searchInput = o.searchInput) !== null && _o$searchInput !== void 0 ? _o$searchInput : r.searchInput) !== null && _ref !== void 0 ? _ref : t.searchInput;
            n(_objectSpread(_objectSpread({
              type: r.type
            }, o), {}, {
              searchInput: O,
              abortController: l
            }));
            _context.next = 16;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);

            if (!((_context.t0 == null ? void 0 : _context.t0.name) === "AbortError")) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return");

          case 15:
            n({
              type: s.SET_ERROR,
              error: _context.t0,
              abortController: l
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 11]]);
  }));
  return _R.apply(this, arguments);
}

function C(r) {
  var e = r.load,
      _i = i(I, {
    error: null,
    items: [],
    requestInitiator: null,
    requestState: u.NOT_STARTED,
    searchInput: ""
  }),
      _i2 = _slicedToArray(_i, 2),
      t = _i2[0],
      n = _i2[1];

  return {
    hasError: t.requestState === u.ERROR,
    hasNextPage: t.requestState === u.ERROR ? !1 : t.marker != null,
    isEmpty: t.items.length === 0,
    isLoading: t.requestState === u.IN_PROGRESS,
    isReloading: t.requestState === u.IN_PROGRESS && (t.requestInitiator === s.RELOAD || t.requestInitiator === s.SEARCH),
    items: t.items,
    loadMore: function loadMore() {
      return R({
        type: s.LOAD_MORE
      }, e, t, n);
    },
    reload: function reload() {
      return R({
        type: s.RELOAD
      }, e, t, n);
    },
    requestInitiator: t.requestInitiator,
    searchInput: t.searchInput,
    search: function search(l) {
      return R({
        type: s.SEARCH,
        searchInput: l
      }, e, t, n);
    }
  };
}

export { C as useAsyncList };